import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { useAutomationRecommendationsContext } from './automation-recommendations-context';
import messages from './messages';

/**
 * @param {object} props
 * @typedef {import('../../prop-types/intl').MessageDescriptorPropType} MessageDescriptorPropType
 * @param {MessageDescriptorPropType} props.buttonText
 * @param {() => void} props.onClick
 * @returns {JSX.Element}
 */
export const ContactSalesButton = ({ buttonText, onClick }) => {
  const { salesHasBeenContacted } = useAutomationRecommendationsContext();

  return (
    <Button
      disabled={salesHasBeenContacted}
      disabledTooltipMessage={<FormattedMessage {...messages.disabledButtonMessage} />}
      onClick={onClick}
      theme={THEME_CONSTANTS.primary}
    >
      <FormattedMessage {...buttonText} />
    </Button>
  );
};
